import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "../styles/financeiro.css";

const API = "https://api.ticketdovaqueiro.com/api";

const Financeiro = () => {
    const [eventos, setEventos] = useState([]);
    const [eventoSelecionado, setEventoSelecionado] = useState("");
    const [dadosFinanceiros, setDadosFinanceiros] = useState(null);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [tipoTransacao, setTipoTransacao] = useState("repasse");
    const [valorTransacao, setValorTransacao] = useState("");
    const [loading, setLoading] = useState(false);

    const [entrada, setEntrada] = useState({
        tipo: "patrocinio",
        valor: "",
        descricao: "",
        dataEntrada: new Date().toISOString().slice(0, 10),
    });
    const [salvandoEntrada, setSalvandoEntrada] = useState(false);

    useEffect(() => {
        const buscarEventos = async () => {
            try {
                const response = await axios.get(`${API}/events`);
                setEventos(response.data);
            } catch (error) {
                console.error("❌ Erro ao buscar eventos:", error);
            }
        };
        buscarEventos();
    }, []);

    useEffect(() => {
        if (eventoSelecionado) buscarDadosFinanceiros(eventoSelecionado);
        else setDadosFinanceiros(null);
    }, [eventoSelecionado]);

    const buscarDadosFinanceiros = async (eventoId) => {
        try {
            const response = await axios.get(`${API}/finance/dados-financeiros/${eventoId}`);
            setDadosFinanceiros(response.data);
        } catch (error) {
            console.error("❌ Erro ao buscar dados financeiros:", error);
        }
    };

    const abrirModal = () => setMostrarModal(true);
    const fecharModal = () => {
        setMostrarModal(false);
        setValorTransacao("");
    };

    const realizarTransacao = async () => {
        if (!valorTransacao || parseFloat(valorTransacao) <= 0) {
            alert("⚠️ Informe um valor válido para a transação.");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${API}/finance/realizar-transacao`, {
                eventoId: eventoSelecionado,
                tipo: tipoTransacao,
                valor: parseFloat(valorTransacao),
            });

            alert(response.data.message);
            fecharModal();
            buscarDadosFinanceiros(eventoSelecionado);
        } catch (error) {
            console.error("❌ Erro ao realizar transação:", error);
            alert("Erro ao realizar transação.");
        } finally {
            setLoading(false);
        }
    };

    const registrarEntrada = async (e) => {
        e.preventDefault();
        if (!eventoSelecionado) return alert("Selecione um evento.");

        const valor = Number(String(entrada.valor).replace(",", "."));
        if (!Number.isFinite(valor) || valor <= 0) return alert("Informe um valor válido.");
        if (!entrada.descricao.trim()) return alert("Informe uma descrição para a entrada.");

        setSalvandoEntrada(true);
        try {
            const token = localStorage.getItem("token");
            await axios.post(
                `${API}/admin/financeiro/entradas`,
                {
                    eventoId: eventoSelecionado,
                    tipo: entrada.tipo,
                    valor,
                    descricao: entrada.descricao.trim(),
                    dataEntrada: entrada.dataEntrada || undefined,
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setEntrada({
                tipo: "patrocinio",
                valor: "",
                descricao: "",
                dataEntrada: new Date().toISOString().slice(0, 10),
            });
            await buscarDadosFinanceiros(eventoSelecionado);
            alert("Entrada registrada com sucesso.");
        } catch (error) {
            console.error("Erro ao registrar entrada:", error);
            alert(error.response?.data?.mensagem || "Erro ao registrar entrada.");
        } finally {
            setSalvandoEntrada(false);
        }
    };

    const entradasAtivas = useMemo(
        () => (dadosFinanceiros?.entradas || []).filter((item) => item.status === "ativo"),
        [dadosFinanceiros]
    );

    return (
        <div className="financeiro-container23">
            <h1>Financeiro</h1>
            <label>Selecione o Evento:</label>
            <select value={eventoSelecionado} onChange={(e) => setEventoSelecionado(e.target.value)}>
                <option value="">Selecione...</option>
                {eventos.map((evento) => (
                    <option key={evento._id} value={evento._id}>
                        {evento.nome}
                    </option>
                ))}
            </select>

            {dadosFinanceiros && (
                <div className="financeiro-info23">
                    <h3>Resumo Financeiro</h3>
                    <p><strong>Vendas Pagas:</strong> R$ {Number(dadosFinanceiros.totalVendasPagas || 0).toFixed(2)}</p>
                    <p><strong>Entradas externas (aporte/patrocínio):</strong> R$ {Number(dadosFinanceiros.totalEntradas || 0).toFixed(2)}</p>
                    <p><strong>Total Arrecadado:</strong> R$ {Number(dadosFinanceiros.totalArrecadado || 0).toFixed(2)}</p>
                    <p><strong>Pedidos Pagos:</strong> {dadosFinanceiros.quantidadeTotalPedidosPagos}</p>
                    <p><strong>Total Repassado:</strong> R$ {Number(dadosFinanceiros.totalRepassado || 0).toFixed(2)}</p>
                    <p><strong>Valor a Repassar:</strong> R$ {Number(dadosFinanceiros.valorARepassar || 0).toFixed(2)}</p>

                    <h4>Vendas por Categoria</h4>
                    {Object.entries(dadosFinanceiros.vendasPorCategoria || {}).map(([categoria, dados]) => (
                        <p key={categoria}>
                            <strong>{categoria}</strong> - R$ {Number(dados.total || 0).toFixed(2)} ({dados.quantidade} pedidos)
                        </p>
                    ))}

                    <div style={{ marginTop: 24, padding: 16, border: "1px solid #333", borderRadius: 10 }}>
                        <h4>Adicionar entrada externa</h4>
                        <p style={{ opacity: 0.75, marginTop: 0 }}>
                            Para aporte ou patrocínio que não veio de venda. O valor soma na arrecadação e não sofre taxa do site.
                        </p>
                        <form onSubmit={registrarEntrada} style={{ display: "grid", gap: 10 }}>
                            <select
                                value={entrada.tipo}
                                onChange={(e) => setEntrada((old) => ({ ...old, tipo: e.target.value }))}
                            >
                                <option value="patrocinio">Patrocínio</option>
                                <option value="aporte">Aporte</option>
                            </select>
                            <input
                                type="number"
                                min="0.01"
                                step="0.01"
                                placeholder="Valor"
                                value={entrada.valor}
                                onChange={(e) => setEntrada((old) => ({ ...old, valor: e.target.value }))}
                            />
                            <input
                                type="date"
                                value={entrada.dataEntrada}
                                onChange={(e) => setEntrada((old) => ({ ...old, dataEntrada: e.target.value }))}
                            />
                            <input
                                type="text"
                                maxLength={500}
                                placeholder="Descrição. Ex.: Patrocínio Empresa X"
                                value={entrada.descricao}
                                onChange={(e) => setEntrada((old) => ({ ...old, descricao: e.target.value }))}
                            />
                            <button type="submit" disabled={salvandoEntrada}>
                                {salvandoEntrada ? "Salvando..." : "+ Adicionar entrada"}
                            </button>
                        </form>
                    </div>

                    <h4 style={{ marginTop: 24 }}>Entradas externas ativas</h4>
                    {entradasAtivas.length === 0 ? (
                        <p>Nenhuma entrada externa registrada.</p>
                    ) : (
                        entradasAtivas.map((item) => (
                            <p key={item._id}>
                                <strong>{item.tipo === "patrocinio" ? "Patrocínio" : "Aporte"}</strong>
                                {" — "}{item.descricao || "Sem descrição"}
                                {" — "}<strong>R$ {Number(item.valor || 0).toFixed(2)}</strong>
                            </p>
                        ))
                    )}

                    <button onClick={abrirModal}>💰 Fazer Repasse</button>
                </div>
            )}

            {mostrarModal && (
                <div className="modal23">
                    <div className="modal-content23">
                        <h3>Fazer Repasse / Estorno</h3>
                        <label>Tipo de Transação:</label>
                        <select onChange={(e) => setTipoTransacao(e.target.value)} value={tipoTransacao}>
                            <option value="repasse">Repasse</option>
                            <option value="estorno">Estorno</option>
                        </select>

                        <label>Valor:</label>
                        <input
                            type="number"
                            placeholder="Informe o valor"
                            value={valorTransacao}
                            onChange={(e) => setValorTransacao(e.target.value)}
                        />

                        <div className="modal-buttons">
                            <button onClick={realizarTransacao} disabled={loading}>
                                {loading ? "Processando..." : "✅ Confirmar"}
                            </button>
                            <button onClick={fecharModal} className="cancel-button">❌ Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Financeiro;
